import React from 'react';
import { LAWS } from '../data/mock';

export default function TheLaw() {
  return (
    <section id="l6" className="chapter" style={{ flexDirection: 'column' }}>
      <div style={{ maxWidth: 1200, width: '100%', margin: '0 auto' }}>
        <div className="chapter-eyebrow font-sans">LIFE VI · THE LAW</div>
        <p className="big-prose" style={{ marginBottom: 60 }}>
          Four things are <em><i>engraved</i></em>.<br />
          Everything else is current.
        </p>
        <div className="laws">
          {LAWS.map((l) => (
            <div className="law-card" key={l.id}>
              <div className="law-id font-sans">LAW {l.id}</div>
              <div className="law-title">{l.title}</div>
              <p className="law-body font-sans">{l.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
